<template>
  <div class="white-bg padding-lg padding-top border-radius">
    <div class="flex justify-between">
      <h3>{{ $t('shopIntegral.title') }}</h3>
    </div>

    <!-- 业主信息 -->
    <div class="margin-top">
      <el-row>
        <el-col :span="8">
          <div class="form-group">
            <label class="col-form-label">
              {{ $t('shopIntegral.accountId') }}
            </label>
            <label>{{ shopIntegralInfo.integralId }}</label>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="form-group">
            <label class="col-form-label">
              {{ $t('shopIntegral.accountName') }}
            </label>
            <label>{{ shopIntegralInfo.integralName }}</label>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="form-group">
            <label class="col-form-label">
              {{ $t('shopIntegral.accountBalance') }}
            </label>
            <label>
              {{ shopIntegralInfo.amount }}
              <el-button type="text" @click="openApplyWithholdShopIntegral">
                {{ $t('shopIntegral.withdraw') }}
              </el-button>
            </label>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="vc-line-primary margin-top"></div>

    <div class="margin-top-sm">
      <el-tabs v-model="shopIntegralInfo._currentTab" @tab-click="changeTab(shopIntegralInfo._currentTab)">
        <el-tab-pane :label="$t('shopIntegral.transactionDetails')" name="shopIntegralDetail">
          <shop-integral-detail ref="shopIntegralDetail" v-if="shopIntegralInfo._currentTab === 'shopIntegralDetail'" />
        </el-tab-pane>
        <el-tab-pane :label="$t('shopIntegral.pointsWithdrawal')" name="applyWithholdIntegral">
          <apply-withhold-integral ref="applyWithholdIntegral"
            v-if="shopIntegralInfo._currentTab === 'applyWithholdIntegral'" />
        </el-tab-pane>
      </el-tabs>
    </div>

    <withhold-integral ref="withholdIntegral" />
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryShopIntegral } from '@/api/shop/integralApi'
import ShopIntegralDetail from '@/components/shop/shopIntegralDetail/shopIntegralDetail.vue'
import ApplyWithholdIntegral from '@/components/shop/applyWithholdIntegral/applyWithholdIntegral.vue'
import WithholdIntegral from '@/components/shop/withholdIntegral/withholdIntegral.vue'

export default {
  name: 'ShopIntegral',
  components: {
    ShopIntegralDetail,
    ApplyWithholdIntegral,
    WithholdIntegral
  },
  data() {
    return {
      shopIntegralInfo: {
        integralId: '',
        integralName: '',
        amount: '',
        shopName: '',
        shopId: '',
        _currentTab: 'shopIntegralDetail'
      }
    }
  },
  created() {
    this.loadShopIntegralInfo()
  },
  methods: {
    async loadShopIntegralInfo() {
      try {
        const params = {
          page: 1,
          row: 1,
          shopId: getShopId()
        }
        const res = await queryShopIntegral(params)
        if (res.code === 0 && res.data.length > 0) {
          Object.assign(this.shopIntegralInfo, res.data[0])
          this.changeTab(this.shopIntegralInfo._currentTab)
        }
      } catch (error) {
        console.error('Failed to load shop integral info:', error)
      }
    },
    changeTab(tab) {
      this.shopIntegralInfo._currentTab = tab
      setTimeout(() => {  
        this.$refs[tab].switch({
          integralId: this.shopIntegralInfo.integralId,
          integralName: this.shopIntegralInfo.integralName
        })
      }, 100)
    },
    openApplyWithholdShopIntegral() {
      this.$refs.withholdIntegral.open({
        integralId: this.shopIntegralInfo.integralId,
        amount: this.shopIntegralInfo.amount,
        shopId: this.shopIntegralInfo.shopId
      })
    }
  }
}
</script>

<style scoped>
.white-bg {
  background: #fff;
}

.padding-lg {
  padding: 20px;
}

.padding-top {
  padding-top: 20px;
}

.border-radius {
  border-radius: 4px;
}

.margin-top {
  margin-top: 20px;
}

.margin-top-sm {
  margin-top: 10px;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.vc-line-primary {
  border-top: 1px solid #409EFF;
}
</style>